import { render, staticRenderFns } from "./ProvidersRequests.vue?vue&type=template&id=73b83c4a&"
import script from "./ProvidersRequests.vue?vue&type=script&lang=js&"
export * from "./ProvidersRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports